import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import raffleService from "../services/raffle-service";

export const raffleSearchQuery = z.object({
	search: z.string().optional(),
	status: z.string(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const rafflesQueryOptions = (
	search?: z.infer<typeof raffleSearchQuery>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["raffles", search],
		queryFn: () =>
			raffleService.list(transformSearch(search, ["status", "search"])),
		...options,
	});
};

export const raffleQueryOptions = (raffleId: string) => {
	return queryOptions({
		queryKey: ["raffles", raffleId],
		queryFn: () => raffleService.findById(raffleId),
	});
};

export const useRaffleMutation = (raffleId?: string) => {
	return useMutation({
		mutationKey: ["raffles", raffleId],
		mutationFn: raffleService.upsert,
		meta: {
			successMessage: "Case Raffle saved successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["raffles"] }),
	});
};

export const useRafflingMutation = () => {
	return useMutation({
		mutationKey: ["raffles"],
		mutationFn: raffleService.raffle,
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["raffles"] }),
	});
};

export const useRaffleDeleteMutation = () => {
	return useMutation({
		mutationKey: ["raffles", "delete"],
		mutationFn: raffleService.deleteById,
		meta: {
			successMessage: "Case Raffle archived successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["raffles"],
			});
		},
	});
};
